document.addEventListener("DOMContentLoaded", function() {
  // Target the button inside the layered-images-with-text section
  const moduleButton = document.querySelector(
    '.section-layered-images-with-text .btn'
  );

  if (moduleButton) {
    moduleButton.setAttribute('target', '_blank');
    moduleButton.setAttribute('rel', 'noopener noreferrer');
  }
});
